Odigeo.defineWidget('app_root', Odigeo.RootComponent);
